import { useState, useEffect } from 'react';
import { Shop } from '@card/types';
import { Services } from '@card/commonlib';

export function useShops() {
  const [shops, setShops] = useState<Shop[] | null>(null);

  useEffect(() => {
    Services.getShops().then((shops) => setShops(shops));
  }, []);

  return shops;
}
